// src/hooks/useSearch.js
import {useQuery} from "react-query";
import {fetchSearchList} from "../api/searchApi";

export const useSearchList = (keyword, pageNumber, pageSize) => {
    return useQuery(['searchList', keyword, pageNumber, pageSize], () => fetchSearchList(keyword, pageNumber, pageSize), {
        refetchOnWindowFocus: false, // 根據需求調整
    });
}
